import React from 'react'
import FormField from '@/components/common/FormField'
import MainHeading from '@/components/common/MainHeading'
import Layout from '@/components/layout/Layout'
import { DownloadIcon } from 'lucide-react'

const PayslipDetail: React.FC = () => {
    return (

        <Layout>

            <div className='space-y-6'>
                <MainHeading
                    title='My Payslip'
                    subtitle='Monthly salary statement'
                    buttonText='Download'
                    buttonIcon={<DownloadIcon />}
                />
                <div>
                    <div className='flex items-center justify-end'>
                        <FormField type='select'
                            options={[
                                { label: 'December 2025', value: 'December 2025' },
                                { label: 'November 2025', value: 'November 2025' },
                                { label: 'October 2025', value: 'October 2025' },
                                { label: 'September 2025', value: 'September 2025' },
                                { label: 'August 2025', value: 'August 2025' },
                                { label: 'July 2025', value: 'July 2025' }
                            ]}
                            placeholder='Select Month'
                            className='px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500'
                        />
                    </div>

                    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-lg mt-6">
                        <div className="bg-primary text-white px-5 py-4">
                            <div className="flex items-center gap-2">
                                <span className="text-xl">❤</span>
                                <div className="font-display font-bold text-lg">SADGURU MEDICAL TRUST</div>
                            </div>
                            <div className="text-cyan-50 opacity-90 mt-0.5 text-xs">Nagpur, Maharashtra | SMT/NGO/2008/0142</div>
                            <div className="text-cyan-50 opacity-80 italic text-xs">"Healing with Humanity"</div>
                        </div>
                        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200 bg-slate-50">
                            <div className="font-display font-semibold text-slate-800 text-lg">SALARY SLIP — DECEMBER 2025</div>
                            <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-full border-amber-600 text-amber-700 bg-amber-50">Draft</span>
                        </div>
                        <div className="grid grid-cols-2 gap-x-6 gap-y-1.5 p-5 border-b border-slate-200 text-sm">
                            <div className="col-span-2 text-xs font-semibold text-slate-500 uppercase mb-1">Employee Details</div>
                            <div>
                                <span className="text-slate-500">Name:</span> <span className="font-medium text-slate-800">Priya Sharma</span>
                            </div>
                            <div>
                                <span className="text-slate-500">Employee ID:</span> <span className="font-mono text-slate-800">SMT-0067</span>
                            </div>
                            <div>
                                <span className="text-slate-500">Dept:</span> <span className="text-slate-800">Nursing Services</span>
                            </div>
                            <div>
                                <span className="text-slate-500">Designation:</span> <span className="text-slate-800">Staff Nurse</span>
                            </div>
                            <div>
                                <span className="text-slate-500">PF A/c:</span> <span className="font-mono text-slate-800">PF-SMT-067</span>
                            </div>
                            <div>
                                <span className="text-slate-500">Days Paid:</span> <span className="text-slate-800">26 | LOP: 0</span>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 p-5 gap-x-6 border-b border-slate-200">
                            <div>
                                <div className="font-semibold text-slate-600 uppercase mb-2 text-xs">Earnings</div>
                                <div className="flex justify-between py-1 border-b border-slate-100 text-sm">
                                    <span className="text-slate-700">Basic</span>
                                    <span className="font-mono text-slate-800">₹12,800</span>
                                </div>
                                <div className="flex justify-between py-1 border-b border-slate-100 text-sm">
                                    <span className="text-slate-700">HRA</span>
                                    <span className="font-mono text-slate-800">₹2,560</span>
                                </div>
                                <div className="flex justify-between py-1 border-b border-slate-100 text-sm">
                                    <span className="text-slate-700">Conveyance</span>
                                    <span className="font-mono text-slate-800">₹1,600</span>
                                </div>
                                <div className="flex justify-between py-1 border-b border-slate-100 text-sm">
                                    <span className="text-slate-700">Medical</span>
                                    <span className="font-mono text-slate-800">₹1,250</span>
                                </div>
                                <div className="flex justify-between py-1 border-b border-slate-100 text-sm">
                                    <span className="text-slate-700">Special</span>
                                    <span className="font-mono text-slate-800">₹13,790</span>
                                </div>
                                <div className="flex justify-between py-1.5 font-semibold text-sm">
                                    <span>Gross Total</span>
                                    <span className="font-mono">₹32,000</span>
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold text-slate-600 uppercase mb-2 text-xs">Deductions</div>
                                <div className="flex justify-between py-1 border-b border-slate-100 text-sm">
                                    <span className="text-slate-700">Provident Fund</span>
                                    <span className="font-mono text-red-600">−₹1,536</span>
                                </div>
                                <div className="flex justify-between py-1 border-b border-slate-100 text-sm">
                                    <span className="text-slate-700">Professional Tax</span>
                                    <span className="font-mono text-red-600">−₹200</span>
                                </div>
                                <div className="flex justify-between py-1 border-b border-slate-100 text-sm">
                                    <span className="text-slate-700">ESI</span>
                                    <span className="font-mono text-red-600">−₹0</span>
                                </div>
                                <div className="flex justify-between py-1.5 font-semibold text-sm">
                                    <span>Total Deductions</span>
                                    <span className="font-mono text-red-600">−₹1,736</span>
                                </div>
                            </div>
                        </div>
                        <div className="bg-green-50 border-b border-green-200 text-center py-5">
                            <div className="text-slate-600 text-xs uppercase tracking-wide">Net Pay (Take Home)</div>
                            <div className="font-bold text-green-700 font-display text-3xl mt-1">₹30,264</div>
                            <div className="text-slate-500 mt-1 text-xs">Thirty Thousand Two Hundred Sixty Four Rupees Only</div>
                        </div>
                        <div className="bg-slate-50 border-b border-slate-200 px-5 py-3 flex flex-wrap gap-2 text-xs">
                            <span className="text-slate-500 font-medium mr-2">Leave Balance:</span>
                            <span className="bg-white border border-slate-200 rounded px-2 py-0.5">
                                <span className="font-semibold">EL</span> 12/15</span>
                            <span className="bg-white border border-slate-200 rounded px-2 py-0.5">
                                <span className="font-semibold">CL</span> 8/12</span>
                            <span className="bg-white border border-slate-200 rounded px-2 py-0.5">
                                <span className="font-semibold">SL</span> 10/12</span>
                            <span className="bg-white border border-slate-200 rounded px-2 py-0.5">
                                <span className="font-semibold">CO</span> 2.5/2.5</span>
                        </div>
                        <div className="px-5 py-3 text-[10px] text-slate-400 leading-5">* This is a computer-generated payslip.<br />* No signature required.</div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default PayslipDetail